import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getFinancialTransactionLoading: false,
  getFinancialTransactionFailed: false,
  getFinancialTransactionReject: false,
  getFinancialTransactionMessage: [],
  transactions: [],
  userCredit: '',

  getFinancialTransactionTypesLoading: false,
  getFinancialTransactionTypesFailed: false,
  getFinancialTransactionTypesReject: false,
  getFinancialTransactionTypesMessage: [],
  transactionsTypes: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_FINANCIAL_TRANSACTION_LOADING: {
      return {
        ...state,
        getFinancialTransactionLoading: true,
        getFinancialTransactionFailed: false,
        getFinancialTransactionReject: false,
        getFinancialTransactionMessage: [],
        transactions: [],
        userCredit: '',
      };
    }
    case actionTypes.GET_FINANCIAL_TRANSACTION_SUCCESS: {
      return {
        ...state,
        getFinancialTransactionLoading: false,
        getFinancialTransactionFailed: false,
        getFinancialTransactionReject: false,
        getFinancialTransactionMessage: [],
        transactions: action.payload.financialTransactions,
        userCredit: action.payload.userCredit,
      };
    }
    case actionTypes.GET_FINANCIAL_TRANSACTION_FAILED: {
      return {
        ...state,
        getFinancialTransactionLoading: false,
        getFinancialTransactionFailed: true,
        getFinancialTransactionReject: false,
        getFinancialTransactionMessage: [],
        transactions: [],
        userCredit: '',
      };
    }
    case actionTypes.GET_FINANCIAL_TRANSACTION_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getFinancialTransactionLoading: false,
        getFinancialTransactionFailed: false,
        getFinancialTransactionReject: true,
        getFinancialTransactionMessage: message,
        transactions: [],
        userCredit: '',
      };
    }

    case actionTypes.GET_FINANCIAL_TRANSACTION_TYPES_LOADING: {
      return {
        ...state,
        getFinancialTransactionTypesLoading: true,
        getFinancialTransactionTypesFailed: false,
        getFinancialTransactionTypesReject: false,
        getFinancialTransactionTypesMessage: [],
        transactionsTypes: [],
      };
    }
    case actionTypes.GET_FINANCIAL_TRANSACTION_TYPES_SUCCESS: {
      return {
        ...state,
        getFinancialTransactionTypesLoading: false,
        getFinancialTransactionTypesFailed: false,
        getFinancialTransactionTypesReject: false,
        getFinancialTransactionTypesMessage: [],
        transactionsTypes: action.payload,
      };
    }
    case actionTypes.GET_FINANCIAL_TRANSACTION_TYPES_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getFinancialTransactionTypesLoading: false,
        getFinancialTransactionTypesFailed: true,
        getFinancialTransactionTypesReject: false,
        getFinancialTransactionTypesMessage: message,
        transactionsTypes: [],
      };
    }
    case actionTypes.GET_FINANCIAL_TRANSACTION_TYPES_REJECT: {
      return {
        ...state,
        getFinancialTransactionTypesLoading: false,
        getFinancialTransactionTypesFailed: false,
        getFinancialTransactionTypesReject: true,
        getFinancialTransactionTypesMessage: [],
        transactionsTypes: [],
      };
    }

    default:
      return state;
  }
};